import { Flex, Input } from '@chakra-ui/react'
import Clean from '../../../components/Clean'
import { listFeature } from '../storage'

export default function FiltersFeature() {
    const { clear, ...props } = listFeature.useSearch()

    return (
        <Flex>
            <Clean value={props.value} onClick={clear}>
                <Input w="80" placeholder="🏸 Buscar por nombre" {...props} />
            </Clean>
        </Flex>
    )
}
